import { useLocation } from "wouter";
import { Button } from "@/components/ui/button";
import { Home, ArrowLeft } from "@/lib/icons";
import { SEO } from "@/components/seo";
import { Link } from "wouter";

export default function NotFound() {
  const [, setLocation] = useLocation();

  return (
    <>
      <SEO
        title="Página no encontrada"
        description="La página que buscas no existe o ha sido movida."
      />
      
      <div className="min-h-screen min-h-dvh flex items-center justify-center bg-gradient-to-br from-background via-background to-primary/5">
        <div className="container mx-auto px-4 text-center max-w-2xl">
          <div className="mb-8">
            <h1 className="text-9xl font-bold bg-gradient-to-r from-primary to-primary/50 bg-clip-text text-transparent">
              404
            </h1>
          </div>

          <h2 className="text-3xl md:text-4xl font-display font-bold mb-4">
            Página no encontrada
          </h2>

          <p className="text-lg text-muted-foreground mb-8 max-w-md mx-auto">
            Lo sentimos, la página que buscas no existe o ha sido movida.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              size="lg"
              onClick={() => window.history.back()}
              variant="outline"
              className="gap-2"
              data-testid="button-go-back"
            >
              <ArrowLeft className="h-4 w-4" />
              Volver atrás
            </Button>
            
            <Button
              size="lg"
              onClick={() => setLocation("/")}
              className="gap-2"
              data-testid="button-go-home"
            >
              <Home className="h-4 w-4" />
              Ir al inicio
            </Button>
          </div>

          <div className="mt-12 pt-8 border-t">
            <p className="text-sm text-muted-foreground mb-4">
              ¿Necesitas ayuda? Visita:
            </p>
            <div className="flex flex-wrap gap-4 justify-center text-sm">
              <Link href="/para-creadores" className="text-primary hover:underline">
                Para Creadores
              </Link>
              <Link href="/marcas" className="text-primary hover:underline">
                Para Marcas
              </Link>
              <Link href="/asesorias" className="text-primary hover:underline">
                Asesorías
              </Link>
              <Link href="/blog" className="text-primary hover:underline">
                Blog
              </Link>
              <Link href="/contacto" className="text-primary hover:underline">
                Contacto
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
